import { OurImpactSliceDefaultItem } from 'components/../../prismicio-types';
import { Text } from 'components/@tedui';

import type { JSX } from 'react';

const ListGridComponent = ({ items, textColor }): JSX.Element => {
  return (
    <div className="grid grid-cols-2 gap-6 md-tui:grid-cols-4 md-tui:gap-8 lg-tui:gap-9">
      {items.map((item: OurImpactSliceDefaultItem) => (
        <div className="flex flex-col items-center gap-3 md-tui:gap-3">
          <Text variant="display" useNewTextStyles UNSAFE_className={textColor}>
            {item.number}
          </Text>
          <Text variant="caption" useNewTextStyles UNSAFE_className={textColor}>
            {item.description}
          </Text>
        </div>
      ))}
    </div>
  );
};

export default ListGridComponent;
